/** 不应直接展示给终端用户的技术性 HTTP / 网关文案 */
const TECHNICAL_ERROR_PATTERNS = [
  /^internal server error$/i,
  /^bad gateway$/i,
  /^service unavailable$/i,
  /^gateway timeout$/i,
  /^request failed$/i,
  /^business error$/i,
  /^failed to fetch$/i,
  /^networkerror when attempting to fetch resource\.$/i,
  /^network request failed$/i,
  /^the user aborted a request\.?$/i,
  /^aborterror$/i,
  /^signal timed out$/i,
]

export function isTechnicalErrorMessage(message: string): boolean {
  const trimmed = message.trim()
  if (!trimmed) return true
  return TECHNICAL_ERROR_PATTERNS.some((pattern) => pattern.test(trimmed))
}

type TranslateFn = (key: string, opts?: { defaultValue?: string }) => string

/** 列表 / 页面加载失败时展示给用户的文案（过滤 5xx 等英文技术提示） */
export function friendlyLoadErrorMessage(message: string | null | undefined, t: TranslateFn): string | null {
  if (!message?.trim()) return null
  if (isTechnicalErrorMessage(message)) {
    return t('common.loadFailed', { defaultValue: '加载失败' })
  }
  return message.trim()
}
